import { DataSubset } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isWhereClause } from "./isWhereClause";

/**
 * Type guard to check if a value is a DataSubset.
 *
 * Validates that the object has the required properties of a DataSubset:
 * - Extends NamedObject (name, description?, label?)
 * - Extends WhereClause (level, order, condition?, compoundExpression?)
 * - Has an id string
 *
 * @param obj - The value to check
 * @returns True if the value is a DataSubset, false otherwise
 */
export const isDataSubset = (obj: unknown): obj is DataSubset => {
  // Check NamedObject and WhereClause
  if (!isNamedObject(obj) || !isWhereClause(obj)) return false;
  // Check id
  const chkObj = obj as DataSubset;
  if (typeof chkObj.id !== "string") return false;
  // Everything is good
  return true;
};
